import { render, staticRenderFns } from "./PrkOpenIdFrontChannelLogout.vue?vue&type=template&id=8d1283cc&scoped=true&"
import script from "./PrkOpenIdFrontChannelLogout.vue?vue&type=script&lang=js&"
export * from "./PrkOpenIdFrontChannelLogout.vue?vue&type=script&lang=js&"
import style0 from "./PrkOpenIdFrontChannelLogout.vue?vue&type=style&index=0&id=8d1283cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1283cc",
  null
  
)

export default component.exports